export enum Queries {
    USER_INFO = "user-info",
    USER_KPIS = "user-kpis",
    USER_FIND_ALL = "user-find-all",
    TRANSACTION_KPIS = "transaction-kpis",
    PROGRAM_KPIS = "program-kpis",
    PARTNER_KPIS = "partner-kpis",
    PARTNER_FIND_ALL = "partner-find-all",
    PARTNER_FIND_ALL_WITHOUT_PARENT = "partner-find-all-without-parent",
    PROGRAM_FIND_ALL = "program-find-all",
    POINT_FIND_BY = "point-find-by",
    POINT_FIND_BY_ADDRESS = "point-find-by-address",
    PROGRAM = "program",
    PARTNER = "partner",
    ACCOUNT_NEAR_BALANCE = "account-near-balance",
    ORGANIZATION_BALANCE = "organization-balance",
    PAYMENT_GATEWAY_POINT = "payment-gateway-point",
    POINTS_BALANCE = "points-balance",
    TRANSACTION_FIND_ALL = "transaction-find-all",
    SCHEDULED_MINT_FIND_ALL = "scheduled-mint-find-all",
    CHECK_TRANSACTION = "check-transaction",
    PARTNER_BALANCE = "partner-balance",
    PROGRAM_BALANCE = "program-balance",
    TRANSACTIONS_STATS = "transactions-stats",
    USERS_STATS = "users-stats",
    ADDRESS_EXISTS = "address-exists",
    POINTS_OF_SELL = "points-of-sell",
    GET_CITIES = "get-cities",
    RELEASE_STRATEGY_FIND_ALL = "release-strategy-find-all",
    APPROVERS_FIND_ALL = "approvers-find-all",
    RELEASE_STRATEGY_OPERATIONS = "release-strategy-operations",
    GIFTCARDS_FIND_ALL = "gift-cards-find-all",
    GIFTCARDS_STOCK_FIND_ALL = "gift-cards-stock-find-all",
    GIFTCARDS_KPIS = "gift-cards-kpis",
    PARTNER_GIFTCARD_STRATEGIES = "partner-giftcard-strategies",
    GET_GIFTCARD_CATEGORIES = "get-giftcard-categories",
    GIFTCARD_PREVIEW_VOUCHER = "gift-card-preview-voucher",
}
